export enum ErrorType {
  CLIENT, SERVER, CODE
}
